export const DiscountCodeErrorCode = {
  INVALID: 100,
  EXPIRED: 200,
};

export const DiscountCodeErrorMessage = {
  [DiscountCodeErrorCode.INVALID]: 'Please enter a valid discount code.',
  [DiscountCodeErrorCode.EXPIRED]: 'That discount code has expired.',
};
